
















import { Component, Prop, Vue } from "vue-property-decorator";
import wx from "wx-jssdk-ts";

@Component({ name: "article-card" })
export default class ArticleCard extends Vue {
  @Prop() public title!: string;
  @Prop() public icon!: string;
  @Prop() public watch!: number;
  @Prop() public url!: string;
  @Prop() public shareContent!: string;

  public onClick() {
    this.$emit("on-change-show", true);
    this.$emit("on-click-share", this.onMenuShareTimeline());
  }

  public onMenuShareTimeline() {
    return {
      title: this.title,
      link: this.url,
      imgUrl: this.icon,
      desc: this.shareContent,
      success(): void {
        console.log("分享回调");
      },
      cancel(): void {
        console.log("分享取消");
      },
    };
  }

  public openUrl() {
    window.location.href = this.url;
  }
}
